export default "__VITE_ASSET__BV8ZbDfv__"